import { Link } from 'react-router-dom'
import { useLocale, TranslationKey } from '@/i18n'

export function Footer() {
  const { t, localizeHref } = useLocale()

  const footerSections: {
    titleKey: TranslationKey
    links: { labelKey: TranslationKey; href: string; external?: boolean }[]
  }[] = [
    {
      titleKey: 'footer.topics',
      links: [
        { labelKey: 'section.vision-product-market', href: localizeHref('/faq/vision-product-market/what-is-rexhook') },
        { labelKey: 'section.technical', href: localizeHref('/faq/technical/v4-hooks') },
        { labelKey: 'section.team-trust', href: localizeHref('/faq/team-trust/overview') },
      ],
    },
    {
      titleKey: 'footer.moreTopics',
      links: [
        { labelKey: 'section.revenue', href: localizeHref('/faq/revenue/how-makes-money') },
        { labelKey: 'section.participation', href: localizeHref('/faq/participation/go-to-market') },
      ],
    },
  ]

  return (
    <footer className="border-t border-white/[0.06] bg-[#060608]">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-8 md:py-10">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row justify-between gap-10 mb-10">
          {/* Logo */}
          <Link to={localizeHref('/')} className="flex items-center gap-3 self-start">
            <img
              src="/logo_footer.svg"
              alt="RexHook"
              className="h-10"
            />
          </Link>

          {/* Links Grid */}
          <div className="grid grid-cols-2 gap-8 md:gap-12">
            {footerSections.map((section) => (
              <div key={section.titleKey}>
                <h4 className="text-[13px] font-medium text-white mb-3">
                  {t(section.titleKey)}
                </h4>
                <ul className="space-y-2">
                  {section.links.map((link) => (
                    <li key={link.labelKey}>
                      {link.external ? (
                        <a
                          href={link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[13px] text-white/40 hover:text-white/70 transition-colors"
                        >
                          {t(link.labelKey)}
                        </a>
                      ) : (
                        <Link
                          to={link.href}
                          className="text-[13px] text-white/40 hover:text-white/70 transition-colors"
                        >
                          {t(link.labelKey)}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-white/[0.06]">
          <span className="text-[12px] text-white/30">{t('footer.copyright')}</span>
          <a
              href="https://x.com/REXHOOKS"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 hover:text-white/60 transition-colors"
              aria-label={t('footer.twitterAria')}
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
        </div>
      </div>
    </footer>
  )
}
